

$.fn.scrollLink = function (options) {

	const opt = $.extend({
		header: '',
	}, options);

	$( this ).each(function() {

		let trigger = $(this);

		let target = $( trigger.attr('href') );

		trigger.on( 'click', function(e) {
			e.preventDefault();

			let height;

			if ( opt.header ) {
				height = target.offset().top - $(opt.header).height();
			} else {
				height = target.offset().top;
			}
			console.log(target.offset().top);
			console.log($(opt.header).height());

			console.log(height);

			$('html, body').animate({ scrollTop: height }, 500, 'linear' );
		});
	});

	return this;

}
